import * as Yup from 'yup';

/**
 * Validation schema for Indoor Casepaper form
 */
export const validationSchema = Yup.object().shape({
    notes: Yup.string(),
    // medicines: Yup.array().of(
    //     Yup.object().shape({
    //         medicineName: Yup.string().required('Medicine name is required'),
    //         days: Yup.number()
    //             .required('Days are required')
    //             .min(1, 'Days must be at least 1')
    //             .integer('Days must be a whole number'),
    //         whenToTake: Yup.array()
    //             .min(1, 'Please select when to take')
    //             .required('When to take is required'),
    //         howMuch: Yup.string().required('Quantity is required'),
    //         date: Yup.string().required('Date is required'),
    //         anupan: Yup.string(),
    //     })
    // ),
});

export const medicinesValidationSchema = Yup.object().shape({
    medicines: Yup.array().of(
        Yup.object().shape({
            medicineName: Yup.string().required('Medicine name is required'),
            days: Yup.number()
                .required('Days are required')
                .min(1, 'Days must be at least 1')
                .integer('Days must be a whole number'),
            whenToTake: Yup.array()
                .min(1, 'Please select when to take')
                .required('When to take is required'),
            howMuch: Yup.string().required('Quantity is required'),
            date: Yup.string().required('Date is required'),
            anupan: Yup.string(),
        })
    ),
});